// todo: удалить файл, когда будет middleware на обработку ошибок у dcpcApi
import { toaster } from 'evergreen-ui';
import React from "react";

/**
 * Отображение ошибки пользователю для query запросов.
 * @param {object} catchQuery объект с ошибкой, пойманный в onQueryStarted
 * @param {string} textErr продолжение для "Ошибка выгрузки", если нужно
 * @param {string} idToast
 * @example
 * getToasterError(err, 'типов событий', 'eventtypes');
 */
export function getToasterError(catchQuery, textErr = '', idToast = '') {
  const err = catchQuery?.error?.data?.message || catchQuery?.error?.name;
  toaster.danger(`Ошибка выгрузки ${textErr}: ${err}`, { id: idToast });
}

/**
 * Функция проверяет загружаются ли данные с множества query запросов
 * @param {object[]} queries массив объектов query от useGetQuery
 * @returns {boolean} true - если хоть в одном query идет загрузка
 * @example
 * const query1 = useGet1Query();
 * ...
 * // лучше обернуть в мемо
 *   const isLoading = React.useMemo(() => getQueriesIsLoading([query1, query2, ...]), [query1, query2, ...]);
 */
export function getQueriesIsLoading(queries) {
  return queries.some((q) => q.isLoading || q.isFetching);
}

export function useEffectedState(effect) {
  const [state, setState] = React.useState(effect);
  React.useEffect(() => setState(effect), [effect]);
  return [state, setState];
}
